import { Link } from "react-router-dom";
import type { ContentCategory } from "@/types/content";
import SectionHeading from "@/components/feature/SectionHeading";

export default function CategoryGrid({ categories }: { categories: ContentCategory[] }) {
  return (
    <section id="categories" className="w-full px-4 md:px-8 py-14 md:py-20">
      <SectionHeading
        eyebrow="Categories"
        title="按你关心的方向逛"
        description="七个内容分区，覆盖从台前到幕后、从作品到行业的不同围观角度。"
        align="center"
      />

      <div className="mt-8 md:mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {categories.map((category) => (
          <Link
            key={category.id}
            to={`/topics?category=${category.id}`}
            className="reveal group h-full flex flex-col rounded-lg bg-background-50 border border-background-200/80 p-5 hover:border-accent-300 hover:bg-accent-50/60 transition-colors duration-300"
          >
            <span className="w-11 h-11 flex items-center justify-center rounded-xl bg-accent-100 text-accent-800 text-xl transition-transform duration-300 group-hover:scale-105">
              <i className={category.icon} />
            </span>
            <h3 className="mt-4 text-base font-bold text-foreground-950">{category.name}</h3>
            <p className="mt-2 flex-1 text-xs md:text-sm leading-relaxed text-foreground-600">
              {category.desc}
            </p>
            <span className="mt-4 inline-flex items-center gap-1 text-xs text-foreground-500 group-hover:text-accent-700 transition-colors">
              {category.count} 个话题
              <i className="ri-arrow-right-line" />
            </span>
          </Link>
        ))}

        <article className="reveal h-full flex flex-col justify-between rounded-lg bg-secondary-100/80 border border-secondary-200 p-5">
          <div>
            <span className="w-11 h-11 flex items-center justify-center rounded-xl bg-secondary-500 text-background-50 text-xl">
              <i className="ri-add-line" />
            </span>
            <h3 className="mt-4 text-base font-bold text-secondary-950">还没找到想看的？</h3>
            <p className="mt-2 text-xs md:text-sm leading-relaxed text-secondary-900/80">
              把你关注的话题丢进讨论区，热度够高就会被编辑整理进榜单。
            </p>
          </div>
          <Link
            to="/discussion"
            className="mt-4 inline-flex items-center gap-1.5 text-xs text-secondary-950 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            去提议题
            <i className="ri-arrow-right-line" />
          </Link>
        </article>
      </div>
    </section>
  );
}